import React from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import AppIcon from "./AppIcon";

export default function AppCard({ app, onOpen }) {
  const restricted = app.category === "STAFF";

  return (
    <button
      type="button"
      className="uas-app-card"
      onClick={() => onOpen(app)}
      aria-label={`Open ${app.name}`}
    >
      {app.cardImage && (
        <div className="uas-app-card__media">
          <img src={app.cardImage} alt={`${app.name} preview`} />
        </div>
      )}

      <div className="uas-app-card__top">
        <AppIcon app={app} />
        <div className="uas-app-card__body">
          <div className="uas-app-card__title-row">
            <h3>{app.name}</h3>
            {restricted && (
              <span className="uas-restricted-pill">
                <LockOutlinedIcon fontSize="inherit" />
                Restricted
              </span>
            )}
          </div>
          <p>{app.shortDescription}</p>
        </div>
      </div>

      <div className="uas-app-card__meta">
        <span>{app.latestRelease ? `v${app.latestRelease.version}` : "Coming soon"}</span>
        <span>{app.platform || "ANDROID"}</span>
        <span className="uas-app-card__open">
          View app
          <ArrowForwardRoundedIcon fontSize="inherit" />
        </span>
      </div>
    </button>
  );
}
